import Vue from 'vue'
import Vuex from 'vuex'
import News from './news'
import Expert from './expert'
import Match from './match'
import Work from './works'
import MyWorks from './myWorks'
import WorkTop from './workTop'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    News,
    Expert,
    Match,
    Work,
    MyWorks,
    WorkTop
  }
})
